function NoResults() {
  return (
    <tr className="d-flex align-content-center noResult justify-content-center">
      <td className="text-center">
        <h2>No Result</h2>
      </td>
    </tr>
  );
}

export default NoResults;
